import { render, staticRenderFns } from "./FlagFilledIcon.vue?vue&type=template&id=051caa20&"
import script from "./FlagFilledIcon.vue?vue&type=script&lang=js&"
export * from "./FlagFilledIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports